export default __webpack_public_path__ + "static/media/carpe-white.617df169.svg";